module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/first-post"},"excerpt":"First blog post I just installed Pelican for my professional blog. My intention is to blog once every 1-2 weeks. Let's see.... Why did I…","timeToRead":1,"frontmatter":{"title":"First Post","tags":["github","blog"],"cover":"/logos/logo-1024.png","date":"2017-11-20 20:00"}}}]}},"pathContext":{"category":"blaat"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/categories-blaat.json
// module id = 463
// module chunks = 28831943093088